import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import ScrollReveal from "./ScrollReveal";
import { useInView } from "react-intersection-observer";
import {
  MapPin,
  // Phone,
  Mail,
  Linkedin,
  Twitter,
  Facebook,
  Youtube,
} from "lucide-react";
const SyntheraLogo = ({
  textColor = "#FAFBFB",
  className,
  width = "100%",
  // height = "auto", // Keep this auto!
}) => (
  <svg
    width={width}
    // height={height}
    viewBox="0 0 1650 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    // style={style} // Apply the style here
    // preserveAspectRatio="xMinYMid meet"
  >
    <path
      d="M360.866 194.315H453.215C455.655 194.315 457.049 195.535 457.049 198.149V215.05C457.049 217.49 455.655 218.884 453.215 218.884H365.919C359.646 218.884 356.684 221.846 356.684 228.293V234.217C356.684 240.49 359.472 243.104 365.919 243.104H431.086C450.602 243.104 461.579 254.255 461.579 273.771V287.884C461.579 305.832 450.776 316.286 430.738 316.286H334.207C331.593 316.286 330.373 315.066 330.373 312.453V295.551C330.373 293.112 331.593 291.718 334.207 291.718H425.685C431.783 291.718 434.92 288.756 434.92 282.309V275.165C434.92 268.892 432.306 266.278 425.859 266.278H360.518C341.002 266.278 330.199 255.127 330.199 235.611V222.717C330.199 204.77 340.828 194.315 360.866 194.315Z"
      fill={textColor}
    />
    <path
      d="M477.683 194.315H502.077C504.168 194.315 505.214 194.838 506.259 196.406L552.085 257.217L598.086 196.406C599.305 194.838 600.351 194.315 602.267 194.315H625.616C627.707 194.315 628.404 196.058 627.184 197.8L564.631 278.998V312.453C564.631 314.892 563.237 316.286 560.623 316.286H541.979C539.365 316.286 537.971 314.892 537.971 312.453V278.998L475.941 197.8C474.721 196.058 475.592 194.315 477.683 194.315Z"
      fill={textColor}
    />
    <path
      d="M660.545 194.315H676.227C688.773 194.315 690.864 196.929 696.439 204.596L760.561 289.627C761.084 290.498 761.781 290.847 762.826 290.847H764.394C765.266 290.847 765.788 290.324 765.788 289.104V198.149C765.788 195.535 767.008 194.315 769.622 194.315H788.266C790.88 194.315 792.099 195.535 792.099 198.149V298.165C792.099 311.93 787.395 316.286 776.417 316.286H760.91C748.364 316.286 746.273 313.672 740.872 306.006L676.576 220.975C675.879 220.104 675.356 219.755 674.31 219.755H672.742C671.697 219.755 671.348 220.278 671.348 221.497V312.453C671.348 315.066 669.954 316.286 667.515 316.286H648.871C646.257 316.286 645.037 315.066 645.037 312.453V212.437C645.037 198.672 649.568 194.315 660.545 194.315Z"
      fill={textColor}
    />
    <path
      d="M815.019 194.315H951.278C953.891 194.315 955.285 195.535 955.285 198.149V215.225C955.285 217.838 953.891 219.058 951.278 219.058H896.391V312.453C896.391 315.066 895.346 316.286 892.732 316.286H873.739C871.3 316.286 869.906 315.066 869.906 312.453V219.058H815.019C812.58 219.058 811.186 217.838 811.186 215.225V198.149C811.186 195.535 812.58 194.315 815.019 194.315Z"
      fill={textColor}
    />
    <path
      d="M1086.32 194.315H1105.14C1107.76 194.315 1109.15 195.535 1109.15 198.149V312.453C1109.15 315.066 1107.76 316.286 1105.14 316.286H1086.32C1083.89 316.286 1082.49 315.066 1082.49 312.453V266.627H1000.95V312.453C1000.95 315.066 999.726 316.286 997.112 316.286H978.294C975.68 316.286 974.46 315.066 974.46 312.453V198.149C974.46 195.535 975.68 194.315 978.294 194.315H997.112C999.726 194.315 1000.95 195.535 1000.95 198.149V242.929H1082.49V198.149C1082.49 195.535 1083.89 194.315 1086.32 194.315Z"
      fill={textColor}
    />
    <path
      d="M1183.25 194.315H1259.92C1262.35 194.315 1263.75 195.535 1263.75 198.149V215.05C1263.75 217.49 1262.35 218.884 1259.92 218.884H1183.42C1165.48 218.884 1160.77 223.937 1160.77 242.232V243.104H1258.87C1261.31 243.104 1262.7 244.323 1262.7 246.937V262.445C1262.7 265.058 1261.31 266.278 1258.87 266.278H1160.77V268.369C1160.77 286.665 1165.48 291.718 1183.42 291.718H1259.92C1262.35 291.718 1263.75 293.112 1263.75 295.551V312.453C1263.75 315.066 1262.35 316.286 1259.92 316.286H1183.25C1147.88 316.286 1134.46 303.566 1134.46 270.286V240.316C1134.46 207.035 1147.88 194.315 1183.25 194.315Z"
      fill={textColor}
    />
    <path
      d="M1292.61 194.315H1386C1411.96 194.315 1423.46 205.99 1423.46 230.035V240.142C1423.46 260.354 1415.45 272.202 1398.2 275.687L1427.3 311.756C1428.69 313.498 1427.82 316.286 1425.03 316.286H1401.68C1398.89 316.286 1398.02 315.589 1396.8 314.021L1369.1 278.649H1313.86V312.453C1313.86 315.066 1312.64 316.286 1310.03 316.286H1291.21C1288.6 316.286 1287.38 315.066 1287.38 312.453V199.543C1287.38 196.058 1289.12 194.315 1292.61 194.315ZM1313.86 255.649H1380.6C1392.45 255.649 1396.8 251.467 1396.8 241.013V233.695C1396.8 223.066 1392.27 218.71 1380.6 218.71H1316.13C1314.56 218.71 1313.86 219.232 1313.86 220.626V255.649Z"
      fill={textColor}
    />
    <path
      d="M1515.51 194.315H1525.79C1534.85 194.315 1540.08 196.929 1545.83 207.558L1603.5 312.279C1604.72 314.718 1604.2 316.286 1601.41 316.286H1579.28C1577.02 316.286 1575.97 315.763 1575.28 314.195L1563.78 292.937H1480.31L1468.99 314.195C1468.12 315.763 1467.25 316.286 1464.98 316.286H1442.15C1439.37 316.286 1438.84 314.718 1440.06 312.279L1497.22 207.558C1502.79 196.929 1508.19 194.315 1515.51 194.315ZM1492.51 270.286H1551.4L1524.4 220.278C1523.87 219.407 1523.18 219.058 1522.31 219.058H1521.26C1520.39 219.058 1519.87 219.407 1519.34 220.278L1492.51 270.286Z"
      fill={textColor}
    />
    <path
      d="M192.127 141L59 274.127H192.127V326.11H84.3575C70.3529 326.11 59 314.757 59 300.752V274.127V218.701C59 211.976 61.6716 205.526 66.427 200.77L126.197 141H192.127Z"
      fill="url(#paint0_linear_4_195)"
    />
    <path
      d="M141.412 378.092L274.539 244.966H141.412V192.983H249.181C263.186 192.983 274.539 204.336 274.539 218.34V244.966V300.392C274.539 307.117 271.867 313.567 267.112 318.322L207.341 378.092H141.412Z"
      fill="url(#paint1_linear_4_195)"
    />
    <g
      clipPath="url(#clip0_4_298)"
      // transform="translate(330,342) scale(1.7) translate(-330,-342)"
      // stroke="#032D28"
      // strokeWidth="0.6"
    >
      <path
        d="M363.575 363.259V367.295C363.575 371.305 361.402 373.251 356.925 373.251H330.387V370.565H355.478C358.449 370.565 360.292 368.703 360.292 365.699V363.662C360.292 360.664 358.553 358.944 355.53 358.944H336.843C332.47 358.944 330.342 356.79 330.342 352.346V348.66C330.342 344.651 332.502 342.704 336.94 342.704H362.278V345.39H338.387C335.377 345.39 333.573 347.207 333.573 350.257V351.95C333.573 354.941 335.331 356.661 338.387 356.661H357.022C361.369 356.661 363.575 358.88 363.575 363.259Z"
        fill={textColor}
      />
      <path
        d="M412.336 354.24V356.661H441.488V358.944H412.336V361.715C412.336 368.164 414.678 370.565 420.985 370.565H441.787V373.251H420.933C412.012 373.251 409.15 370.578 409.15 362.26V353.689C409.15 345.377 412.012 342.704 420.933 342.704H441.787V345.39H420.985C414.678 345.39 412.336 347.791 412.336 354.24Z"
        fill={textColor}
      />
      <path
        d="M490.605 354.442V361.514C490.605 367.989 493.07 370.513 499.403 370.513H520.503V373.251H499.15C490.235 373.251 487.367 370.578 487.367 362.26V353.689C487.367 345.377 490.235 342.704 499.15 342.704H520.503V345.442H499.403C493.07 345.442 490.605 347.966 490.605 354.442Z"
        fill={textColor}
      />
      <path
        d="M603.852 342.704V362.26C603.852 370.578 600.991 373.251 592.07 373.251H577.769C568.848 373.251 565.986 370.578 565.986 362.26V342.704H569.218V361.514C569.218 367.989 571.683 370.513 578.016 370.513H591.823C598.117 370.513 600.569 367.989 600.569 361.514V342.704H603.852Z"
        fill={textColor}
      />
      <path
        d="M685.209 353.643V350.75C685.209 344.962 682.815 342.704 676.664 342.704H650.633V373.251H653.864V362.487H672.888L681.316 373.251H684.982L676.223 362.39L679.727 361.683C682.439 361.131 685.209 359.749 685.209 353.643ZM675.12 360.249H653.864V348.063C653.864 346.461 655.025 345.345 656.68 345.345H675.12C679.636 345.345 681.926 347.512 681.926 351.801V353.89C681.926 358.107 679.636 360.249 675.12 360.249Z"
        fill={textColor}
      />
      <path
        d="M734.861 342.704H731.623V373.251H734.861V342.704Z"
        fill={textColor}
      />
      <path
        d="M816.444 342.704V345.442H799.6V373.251H796.362V345.442H779.57V342.704H816.444Z"
        fill={textColor}
      />
      <path
        d="M896.342 342.704L879.926 364.018V373.251H876.637V364.018L860.357 342.704H863.868L878.505 362.124L893.195 342.704H896.342Z"
        fill={textColor}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4_195"
        x1="259.262"
        y1="242.282"
        x2="38.7138"
        y2="329.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAA42" />
        <stop offset="1" stopColor="#05663D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4_195"
        x1="259.262"
        y1="242.282"
        x2="38.7138"
        y2="329.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAA42" />
        <stop offset="1" stopColor="#05663D" />
      </linearGradient>
      <clipPath id="clip0_4_195">
        <rect
          width="566"
          height="30.5472"
          fill="white"
          transform="translate(330.342 342.704)"
        />
      </clipPath>
    </defs>
  </svg>
);

// --- Data ---
const companyLinks = [
  { name: "About", path: "/company/about" },
  { name: "Careers", path: "/company/careers" },
  { name: "Industries", path: "/company/industries" },
];
const solutionsLinks = [
  {
    name: "Enterprise Cyber Security",
    path: "/solutions/enterprise-cyber-security",
  },
  {
    name: "AI Security and Governance",
    path: "/solutions/ai-security-and-governance",
  },
  { name: "Operational Analytics", path: "/solutions/Data-Analytics" },
];
const servicesLinks = [
  {
    name: "Security Consultation",
    path: "/services/security-consulting-advisory",
  },
  { name: "Design and Deploy", path: "/services/design-and-deploy" },
  {
    name: "Managed Security Services",
    path: "/services/managed-security-services",
  },
  {
    name: "Detection and Response",
    path: "/services/detection-and-response",
  },
  { name: "Incident Response", path: "/services/incident-response" },
];
// Certificates Data based on your images
// const certificates = [
//   {
//     name: "ISO 27001 Certified",
//     icon: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1768142786/iso-27001-1_xl4yu7.svg",
//   },
//   {
//     name: "SOC2 Approved",
//     icon: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1768142786/soc2-1_zocmsf.svg",
//   },
//   {
//     name: "GDPR Compliant",
//     icon: "https://res.cloudinary.com/dpn3bkjba/image/upload/v1768142786/gdpr-icon_nu2uqh.svg",
//   },
// ];

const AnimatedWave = () => (
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
    <svg
      className="absolute bottom-0 left-0 w-full h-auto"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
    >
      <motion.path
        fill="#00C896"
        fillOpacity="0.1"
        d="M0,160L48,181.3C96,203,192,245,288,256C384,267,480,245,576,208C672,171,768,117,864,117.3C960,117,1056,171,1152,192C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        initial={{ y: 20 }}
        animate={{ y: [20, -20, 20] }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
      ></motion.path>
    </svg>
  </div>
);

const FooterLink = ({ to, children }) => (
  <Link
    to={to}
    className="text-gray-300 hover:text-white transition-colors duration-300 no-underline"
  >
    {children}
  </Link>
);

const Footer = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const controls = useAnimation();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePosition({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <footer
      ref={ref}
      onMouseMove={handleMouseMove}
      className="relative bg-[#032d28] text-white overflow-hidden pt-24"
    >
      <AnimatedWave />

      <motion.div
        className="pointer-events-none absolute -inset-px rounded-xl opacity-20"
        style={{
          background: `radial-gradient(400px at ${mousePosition.x}px ${mousePosition.y}px, rgba(0, 200, 150, 0.15), transparent 80%)`,
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <ScrollReveal>
          {/* Top CTA Section */}
          <motion.div
            className="text-center mb-20"
            variants={containerVariants}
            initial="hidden"
            animate={controls}
          >
            <motion.div variants={itemVariants} className="mb-6">
              <div className="inline-block w-12 h-12 border-4 border-[#00C896] rounded-full p-1">
                <div className="w-full h-full bg-[#00C896]/30 rounded-full" />
              </div>
            </motion.div>
            <motion.h2
              variants={itemVariants}
              className="text-4xl md:text-5xl font-bold mb-4"
            >
              Ready for <span className="text-[#00C896]">Whatever's Next?</span>
            </motion.h2>
            <motion.p
              variants={itemVariants}
              className="max-w-2xl mx-auto text-gray-300 mb-8"
            >
              With Synthera, any organization can reap the full benefits of
              digital transformation, move at the speed of business, and
              innovate with confidence.
            </motion.p>
            <motion.div variants={itemVariants}>
              <Link to="/Contact">
                <motion.button
                  whileHover={{
                    scale: 1.05,
                    boxShadow: "0px 0px 20px rgba(0, 200, 150, 0.5)",
                  }}
                  whileTap={{ scale: 0.95 }}
                  className="px-8 py-3 rounded-full bg-[#00C896] text-black font-bold hover:bg-[#2cfab5] transition-colors duration-300"
                >
                  Contact Our Experts
                </motion.button>
              </Link>
            </motion.div>
          </motion.div>

          {/* --- FOOTER LINKS GRID --- */}
          <motion.div
            className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-16 text-sm"
            variants={containerVariants}
            initial="hidden"
            animate={controls}
          >
            {/* Company */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="font-semibold text-lg mb-4 pl-8 text-white">
                Company
              </h4>
              <ul className="space-y-3 pl-8">
                {companyLinks.map((link) => (
                  <li key={link.name}>
                    <FooterLink to={link.path}>{link.name}</FooterLink>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Solutions */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="font-semibold text-lg mb-4 pl-8 text-white">
                Solutions
              </h4>
              <ul className="space-y-3 pl-8">
                {solutionsLinks.map((link) => (
                  <li key={link.name}>
                    <FooterLink to={link.path}>{link.name}</FooterLink>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Services */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="font-semibold text-lg mb-4 pl-8 text-white">
                Services & Use Cases
              </h4>
              <ul className="space-y-3 pl-8">
                {servicesLinks.map((link) => (
                  <li key={link.name}>
                    <FooterLink to={link.path}>{link.name}</FooterLink>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Follow Us & Contact */}
            <motion.div variants={itemVariants} className="space-y-4">
              <h4 className="font-semibold text-lg mb-4 pl-8 text-white">
                Follow Us
              </h4>
              <div className="flex items-center space-x-4 text-gray-400 pl-8">
                <motion.a
                  href="https://www.linkedin.com/company/syntherasecurity/"
                  target="_blank"
                  whileHover={{ y: -3, color: "#00A0DC" }}
                  className="bg-gray-800/50 p-2 rounded-full no-underline"
                >
                  <Linkedin size={16} />
                </motion.a>
                <motion.a
                  href="https://twitter.com/SyntheraSec"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -3, color: "#1DA1F2" }}
                  className="bg-gray-800/50 p-2 rounded-full no-underline"
                >
                  <Twitter size={16} />
                </motion.a>
                <motion.a
                  href="#"
                  target="_blank"
                  whileHover={{ y: -3, color: "#1877F2" }}
                  className="bg-gray-800/50 p-2 rounded-full no-underline"
                >
                  <Facebook size={16} />
                </motion.a>
                <motion.a
                  href="#"
                  target="_blank"
                  whileHover={{ y: -3, color: "#FF0000" }}
                  className="bg-gray-800/50 p-2 rounded-full no-underline"
                >
                  <Youtube size={16} />
                </motion.a>
              </div>

              <div className="pt-6 pl-8 space-y-3 text-gray-400 text-sm">
                {/* Address */}
                <p className="flex items-start gap-2">
                  <MapPin size={16} className="mt-1" />
                  <span>
                    {/* #8, First Floor, Khazi Street, Jayanagar, Bangalore */}
                    Opulence, Level 1 Jayanagar, Bangalore, Karnataka, India
                  </span>
                </p>

                {/* Email */}
                <p className="flex items-center gap-2 group">
                  <Mail size={16} />

                  <a
                    href="mailto:sales@syntherasecurity.com"
                    className="hover:text-emerald-400 transition no-underline"
                  >
                    sales@syntherasecurity.com
                  </a>

                  {/* Optional Copy */}
                  {/* <button
                    onClick={() =>
                      navigator.clipboard.writeText(
                        "sales@syntherasecurity.com",
                      )
                    }
                    className="text-xs opacity-0 group-hover:opacity-100 transition"
                  >
                    Copy
                  </button> */}
                </p>
              </div>
            </motion.div>
          </motion.div>

          {/* --- NEW CERTIFICATES SECTION --- */}
          {/* --- UPDATED CERTIFICATES SECTION WITH "COOL" SPACING --- */}
          {/* --- COMPACT CERTIFICATES SECTION --- */}
          {/* <motion.div
            variants={itemVariants}
            initial="hidden"
            animate={controls}
            className="py-10 border-t border-b border-green-600/40" // Reduced vertical padding from py-12 to py-10
          > */}
          {/* <div className="flex flex-wrap justify-around items-center max-w-5xl mx-auto gap-y-8 px-4">
              {certificates.map((cert, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 group transition-all duration-300" // Reduced gap between icon and text
                > */}
          {/* Icon size reduced to w-9 h-9 (36px) */}
          {/* <div className="w-9 h-9 flex items-center justify-center filter grayscale hover:grayscale-0 transition-all duration-500">
                    <img
                      src={cert.icon}
                      alt={cert.name}
                      className="w-full h-full object-contain"
                    />
                  </div> */}

          {/* Text size reduced to text-xs and font weight to medium for a cleaner look */}
          {/* <span className="text-gray-400 group-hover:text-white text-xs font-medium tracking-wider uppercase transition-colors">
                    {cert.name}
                  </span>
                </div>
              ))}
            </div>
          </motion.div> */}

          {/* --- BOTTOM BAR --- */}
          <div className="py-6 flex flex-col md:flex-row items-center justify-between gap-6 text-sm">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
              <Link
                to="/"
                onClick={() => window.scrollTo(0, 0)}
                className="flex items-center gap-2 text-xl font-bold text-white no-underline hover:text-gray-300 transition-colors"
              >
                <SyntheraLogo
                  textColor="#ffffff"
                  className="h-8 md:h-10 w-auto transition duration-300 hover:scale-105"
                />
              </Link>

              <nav className="flex flex-col md:flex-row items-center gap-2 md:gap-6">
                <button
                  onClick={(e) => e.preventDefault()}
                  className="text-white no-underline bg-transparent border-none cursor-not-allowed opacity-70"
                >
                  Data Privacy Notice
                </button>

                <button
                  onClick={(e) => e.preventDefault()}
                  className="text-white no-underline bg-transparent border-none cursor-not-allowed opacity-70"
                >
                  Terms of Service
                </button>

                {/* <Link to="/cookie-settings" className="text-white no-underline">
                  Cookie Settings
                </Link> */}
              </nav>
            </div>

            <div className="text-xs text-gray-500 text-center">
              © {new Date().getFullYear()} Synthera Security. All rights
              reserved.
            </div>
          </div>
        </ScrollReveal>
      </div>
    </footer>
  );
};

export default Footer;
